import { render, staticRenderFns } from "./NotificationBox.vue?vue&type=template&id=dbe8877a"
import script from "./NotificationBox.vue?vue&type=script&lang=js"
export * from "./NotificationBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports